'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var getNonCanonicalPath = exports.getNonCanonicalPath = function getNonCanonicalPath() {
    return global.location.pathname;
};

var getNonCanonicalUrl = exports.getNonCanonicalUrl = function getNonCanonicalUrl() {
    var url = global.location.href;
    var i = url.indexOf('#');
    return i === -1 ? url : url.slice(0, i);
};


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/utils/nonCanonical.js
// module id = 406
// module chunks = 1